import { render, staticRenderFns } from "./SidebarView.vue?vue&type=template&id=13c611ca&scoped=true&lang=pug&"
import script from "./SidebarView.vue?vue&type=script&lang=js&"
export * from "./SidebarView.vue?vue&type=script&lang=js&"
import style0 from "./SidebarView.vue?vue&type=style&index=0&id=13c611ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c611ca",
  null
  
)

export default component.exports